import log from '../../log/index';
import api from '../../../http/api';
import config from '../../../core/config/config.js';
import http from '../../../im-http/index.js';
import storage from '../../../core/utils/storage.js';
import store from '../../../store/index.js';
import Date from '../../../core/utils/date.js';
import _ from 'underscore';
import typeUtil from '../typeUtil/index.js';
import dot from '../dot/index'
import {Message, Notification} from 'element-ui';
import Vue from 'vue';
import toolUtil from '../toolUtil';


let updateMsg = setInterval(() => {
    socket.updateAck.bind(socket)();
}, 1000);
//检测保活
let keepAliveTimeId = setInterval(() => {
    if (socket.webSocket && (socket.webSocket.readyState === WebSocket.OPEN)) {
        let now = Date.getUtcTick();//秒
        let diff = Number((now - socket.lastHeartTimeTick) / 1000);
        if (diff > 60) {
            socket.close();
        }
    }
}, 5000);

let socket = {
    isOpen: false,
    opening: false,//表示在正在打开
    webSocket: undefined,
    messageEvent: [],
    messageKey: [],
    lastHeartTimeTick: 0,
    offlineId: 0,
    heartEvent() {
        if (this.webSocket && (this.webSocket.readyState === WebSocket.OPEN)) {
            let msg = this.createMessage(0, 'heart', 'text', 'p2p', '');
            this.send(msg);
        }
    },
    passFriendMsg() {
        let ackMsg = {
            "id": "123123",
            msgType: "passFriendApply",
            fromClientType: "Web",
            fromDeviceId: "1",
            timestamp: Date.formatDateTime(
                Date.getUtcDate()
            ),
            contentType: "text",
            state: "error",
            fromId: 1,
            toId: 1,
            teamId: 1,
            content: '',
            scene: 'p2p'
        };
        _.each(socket.messageEvent, (el) => {
            el(ackMsg);
        });
    },
    updateAck(msg) {
        if (msg) {
            let ack = storage.get('user_' + storage.get('userId') + '_ack');
            if (!ack) {
                return;
            }
            let ackMsgIndex = _.findIndex(ack, item => {
                return item.id === msg.sourceId;
            });

            if (ackMsgIndex >= 0) {
                ack.splice(ackMsgIndex, 1);
                storage.set('user_' + storage.get('userId') + '_ack', JSON.stringify(ack));
            }

        } else {
            let ackX = storage.get('user_' + storage.get('userId') + '_ack');
            if (!ackX) {
                return;
            }
            if (ackX) {
                let newAck = [];
                _.each(ackX, (item) => {
                    let begin = Date.createDate(item.date);
                    let now = Date.createDate(Date.getUTCDateString());
                    if (now - begin.valueOf() > 5000) {
                        let toId = item.toId;
                        let id = item.id;
                        let messages = storage.getMsg(toId, item.scene);
                        let toMsg = _.find(messages, x => {
                            return x.id === id;
                        });
                        if (!toMsg) {
                            return;
                        }
                        if (toMsg.state === 'sending') {
                            toMsg.state = 'error';

                            let ackMsg = {
                                "id": item.id,
                                msgType: "noService",
                                fromClientType: "Web",
                                fromDeviceId: "1",
                                timestamp: Date.formatDateTime(
                                    Date.getUtcDate()
                                ),
                                contentType: "text",
                                state: "error",
                                fromId: item.fromId,
                                toId: item.toId,
                                teamId: item.teamId,
                                content: '',
                                scene: item.scene
                            };
                            storage.replaceMsg(toId, messages);
                            _.each(socket.messageEvent, (el) => {
                                el(ackMsg);
                            });
                        }


                    } else {
                        newAck.push(item);
                    }
                });
                storage.set('user_' + storage.get('userId') + '_ack', JSON.stringify(newAck));
            }
        }
    },
    heartTimerId: 0,
    connect(token) {

        if (!window.WebSocket) {
            Message({
                message: '浏览器版本过低,请使用最新版的google浏览器',
                type: 'error',
                duration: 3 * 1000
            });
            return;
        }

        if (this.webSocket &&
            (this.webSocket.readyState === WebSocket.CONNECTING || this.webSocket.readyState === WebSocket.OPEN)) {
            return;//表示正在连接 或已经连接成功
        }
        let ws = config.getWS() + token;
        this.webSocket = new WebSocket(ws);

        this.webSocket.onopen = () => {
            socket.isOpen = true;
            log.debug("socket打开");
            this.heartTimerId = setInterval(this.heartEvent.bind(this), 5000);
            socket.lastHeartTimeTick = Date.getUtcTick();
        };
        this.webSocket.onclose = () => {
            // 关闭事件
            this.isOpen = false;
            log.debug("socket关闭");
            clearInterval(this.heartTimerId);
        };
        this.webSocket.onerror = () => {
            this.isOpen = false;
            this.webSocket.close();
            clearInterval(this.heartTimerId);
            log.debug("socket异常");
        };
        this.webSocket.onmessage = function (res) {
            let data = res.data;
            data = JSON.parse(data);
            if (data.msgType === 'getOffline') { //获取离线消息
                if (socket.offlineId) return;
                let getMsg = () => {
                    clearInterval(socket.offlineId);
                    http.getOffline().then(res => {
                        _.each(res.data, (msg) => {
                            log.debug(res);

                            if (msg.msgType === 'applyFriend') {
                                store.state.applyFriendNumber = storage.addApplyFriend(data);
                            }
                            if (msg.msgType === 'message') {
                                socket.showMessage(msg);
                                if (msg.scene === 'p2p') {
                                    socket.addMsg(msg);
                                    socket.addMessage(msg);
                                } else {
                                    socket.addTeamMsg(msg);
                                    socket.addTeamMessage(msg);
                                }

                            }
                            if (msg.msgType === 'updateFriend') {
                                http.getFriend().then(res => {
                                    if (res.code === 'success') {
                                        store.commit('setContact', res.data);
                                    }
                                });
                            }
                            _.each(socket.messageEvent, (el) => {
                                el(msg);
                            });
                        });
                        let ids = _.map(res.data, (msg) => {
                            return msg.id;
                        });
                        ids = ids.toString();
                        http.clearOffline(ids).then(() => {
                            if (res.data && res.data.length) {
                                socket.offlineId = setInterval(getMsg, 1000);
                            }
                        });
                    });
                };
                socket.offlineId = setInterval(getMsg, 1000);
            } else if (data.msgType === 'ackMessage') {
                socket.updateAck(data);
                log.debug(data);
                if (data.scene === 'p2p') {
                    let friendId = data.toId;
                    let chat = storage.getMsg(friendId, data.scene);
                    if (chat) {
                        let msg = _.find(chat, msgx => msgx.id === data.sourceId);
                        if (msg) {
                            msg.state = 'success';
                            storage.replaceMsg(friendId, chat);
                        }
                    }
                } else {
                    let teamId = data.teamId;
                    let teamChat = storage.getMsg(teamId, data.scene);
                    if (teamChat) {
                        let msg = _.find(teamChat, msgx => msgx.id === data.sourceId);
                        if (msg) {
                            msg.state = 'success';
                            storage.replaceMsg(teamId, teamChat);
                        }
                    }
                }
            } else if (data.msgType === 'applyFriend') {
                storage.playNotice();
                store.state.applyFriendNumber = storage.addApplyFriend(data);
            } else if (data.msgType === 'creatTeam') {
                if (storage.get('userId') == data.toId && storage.get('userId') != data.fromId)
                    storage.playNotice();
            } else if (data.msgType === 'message') {
                storage.playNotice();
                if (data.scene === 'p2p') {
                    socket.addMessage(data);
                    socket.addMsg(data);
                } else if (data.scene === 'team') {
                    socket.addTeamMessage(data);
                    socket.addTeamMsg(data);
                }
                socket.showMessage(data);
                let msg = socket.createAckHandlerMessage(data);
                socket.send(msg);
            } else if (data.msgType === 'push') {
                console.log("接收到push消息");
                console.log(data);
                if (data.contentType === 'text') {
                    storage.playNotice();
                    socket.showMessage(data);
                } else if (data.contentType == 'addMagentWithdrawal') {//代理提现审批红点
                    storage.playNotice();
                    log.debug(data);
                    dot.DLTX();
                } else if (data.contentType == 'addComFinRecCheck') {//获取分公司管理 理财充值未处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.companyDot();
                } else if (data.contentType == 'addMagetWithdrawCheck') {//获取商户提现审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.merchantDot();
                } else if (data.contentType == 'addRemit') {//汇款待审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.remitDot();
                } else if (data.contentType == 'addComOrMagetCheck') {//审核分公司/商户数量
                    storage.playNotice();
                    log.debug(data);
                    dot.companyMerchant();
                } else if (data.contentType == 'addMagetLimitBalance') {//商户购入流量审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.merchantLLDot();
                } else if (data.contentType == 'addLimitBalance') {//会员提额审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.userTS();
                } else if (data.contentType == 'addFaultdError') {//商户入金故障单待处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.merchantGold();
                } else if (data.contentType == 'addaddFaultdError') {//会员提现中心-提现故障单待处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.userTX();
                } else if (data.contentType == 'addWithdraw') {//普通理财待审批待处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.PTLC();
                } else if (data.contentType == 'addGobleWithdraw') {//全球理财待审批待处理数量
                    log.debug(data);
                    dot.QQLC();
                } else if (data.contentType == 'addMagetWithdraw') {//商户理财待审批待处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.SHLC();
                } else if (data.contentType == 'addFreeze') {//商户入金冻结待处理数量
                    storage.playNotice();
                    log.debug(data);
                    dot.SHDJ();
                } else if (data.contentType == 'addEntrust') {//兑换待审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.DHSP();
                } else if (data.contentType == 'addRemittanceError') {//汇款故障单待审批数量
                    storage.playNotice();
                    log.debug(data);
                    dot.HKSP();
                } else if (data.contentType == 'addCompanyWithdrawal') {//代理提现-总公司提现红点提示
                    storage.playNotice();
                    log.debug(data);
                    dot.DLTXHEAD();
                } else if (data.contentType == 'addCompanyLimitBalance') {//总公司购入流量审批红点提示
                    storage.playNotice();
                    log.debug(data);
                    dot.HEADLL();
                } else if (data.contentType == 'addDigitCurrency') {//总公司商户数字货币充值审批红点提示
                    storage.playNotice();
                    dot.SHSZHBSP();
                } else if (data.contentType === 'systeamUpdate') {
                    storage.playNotice();
                    Vue.prototype.$message({
                        showClose: true,
                        duration: 0,
                        message: data.content,
                        type: 'warning'
                    });
                }
                    // else if (data.contentType === 'addAnchorCompanyLimit') { //直播公司流量购买
                    //     storage.playNotice();
                    //     log.debug(data);
                    //     dot.anchorCompanyFlow();
                    // }
                    // else if (data.contentType === 'addAnchorLimit') { //直播直播、互动主播流量购买
                    //     storage.playNotice();
                    //    // log.debug('直播直播、互动主播流量购买',data);
                    //     dot.anchorFlow();
                    // }
                    // else if(data.contentType === 'addAnchorDigitCurrency'){//主播数字货币审核
                    //
                    // 	//storage.playNotice();
                    // 	//log.debug('主播数字货币审核',data);
                    // 	dot.anchorDigitCurrency();
                    // }
                    // else if(data.contentType === 'addAnchorFaultdError'){//主播充值故障单
                    // 	//storage.playNotice();
                    // 	//log.debug('主播充值故障单',data);
                    // 	dot.anchorFaultdError();
                    // }
                    //  else if (data.contentType === 'addLiveWithdrawalApproval') { //直播公司提现审批
                    //     storage.playNotice();
                    //     log.debug(data);
                    //     dot.anchorCompanyTX();
                    // }
                    //  else if(data.contentType === 'anchorLimitBalanceNotEnough'){ // 直播公司流量不足1000时， 10min提醒一次
                    //     log.debug('直播公司流量不足1000时', data);
                    //
                    //     if(data.toId === storage.get('userData').id){
                    //         Message.warning(data.content);
                    //     }
                    // } else if(data.contentType === 'anchorNoAcceptGift'){ //
                    //     if(data.toId === storage.get('userData').id){
                    //         log.debug('anchorNoAcceptGift', data);
                    //         Message.warning(data.content);
                    //     }
                // }
                else if (data.contentType === 'addAgentLimitBalance') { //商代流量购入审核
                    storage.playNotice();
                    log.debug(data);
                    dot.MAFlow();
                } else if (data.contentType === 'addcompanydrawalApproval') { //分公司提现审核
                    storage.playNotice();
                    log.debug(data);
                    dot.comWithdrawal();
                } else if (data.contentType === 'sendASingleFailure') {//匹配失败列表
                    storage.playNotice();
                    if (!store.state.matchFailed) {
                        store.dispatch('setMatchFailed', 0);
                    }
                    store.state.matchFailed++;
                    store.dispatch('setMatchFailed', store.state.matchFailed);
                    storage.set('matchFailedsDots', store.state.matchFailed);
                    dot.matchFailed();
                    log.debug('红点：', storage.get('matchFailedsDots'));
                } else if (data.contentType === 'addAdminLuckMeesage') { //幸运理财订单通知
                    storage.playNotice();
                    log.debug(data);
                    dot.addAdminLuckMeesage();
                }
            } else if (data.msgType === 'updateFriend') {
                storage.playNotice();
                http.getFriend().then(res => {
                    if (res.code === 'success') {
                        store.commit('setContact', res.data);
                    }
                });
            } else if (data.msgType === 'heart') {
                socket.lastHeartTimeTick = Date.getUtcTick();
            }
            _.each(socket.messageEvent, (el) => {
                el(data);
            });
        };
    },
    showMessage(msg) {
        let chatX = null;
        let contact = store.state.contact;
        let allGroups = store.state.allGroups;
        if (msg.scene === 'p2p') {
            chatX = _.find(store.state.contact, friend => friend.friendId === msg.fromId);
        } else {
            chatX = _.find(store.state.allGroups, friend => friend.teamId === msg.teamId);
        }

        let title = '';
        let message = msg.content;
        if (chatX) {
            title = chatX.friendNick;
        } else {
            title = "通知"
        }
        if (msg.contentType === 'image') {
            message = '[图片]';
        }
        if (msg.contentType === 'audio') {
            message = '[语音]';
        }
        Notification({title: title, message: message});
    },
    addMsg(data) {
        if (data.msgType !== 'message') {
            return;
        }
        let friendIdX = data.fromId;
        let msgs = storage.getMsg(data.fromId, data.scene);
        if (msgs) {
            store.getters.getUserDetail(data.fromId).then(msg => {
                data.avatar = config.getImageUrl(msg.userImage);
                msgs = storage.getMsg(data.fromId, data.scene);
                msgs.push(data);
                storage.replaceMsg(data.fromId, msgs);
            });

        } else {
            store.getters.getUserDetail(data.fromId).then(msg => {
                data.avatar = config.getImageUrl(msg.userImage);
                msgs = storage.getMsg(data.fromId, data.scene);
                if (msgs) {
                    msgs = [];
                }
                msgs.push(data);
                storage.replaceMsg(data.fromId, msgs);
            });
        }
    },
    addMessage(msg) {
        let friendIdX = msg.fromId;
        let chatUser = storage.getChat();
        let chat = _.find(chatUser, user => user.friendId == friendIdX);
        if (!chat) {
            let chatX = _.find(store.state.contact, friend => friend.friendId === friendIdX);
            chatX.chatNum = 1;
            chatX.lastMsg = msg;
            storage.saveChat(chatX);
        } else {
            if (!chat.chatNum) {
                chat.chatNum = 0;
            }
            chat.chatNum = chat.chatNum + 1;
            chat.lastMsg = msg;
            storage.replaceChat(chatUser);
            let talkTemp = 0;
            for (let i = 0; i < chatUser.length; i++) {
                talkTemp += chatUser[i].chatNum;
            }
            let dots = {
                type: 'chat',
                num: talkTemp
            }
            store.dispatch('setDotActive', dots);
        }
    },
    addTeamMsg(data) {
        if (data.msgType !== 'message') {
            return;
        }
        let friendIdX = data.teamId;
        let msgs = storage.getMsg(friendIdX, data.scene);
        let same = _.find(msgs, item => item.id === data.id);
        if (same != undefined) return;
        if (msgs) {
            store.getters.getUserDetail(data.fromId).then(res => {
                data.avatar = config.getImageUrl(res.userImage);
                msgs = storage.getMsg(friendIdX, data.scene);
                msgs.push(data);
                storage.replaceMsg(friendIdX, msgs);
            });

        } else {
            store.getters.getUserDetail(data.fromId).then(res => {
                data.avatar = config.getImageUrl(res.userImage);
                msgs = storage.getMsg(friendIdX, data.scene);
                if (msgs) {
                    msgs = [];
                }
                msgs.push(data);
                storage.replaceMsg(friendIdX, msgs);
            });
        }
    },
    addTeamMessage(msg) {
        let teamIdX = msg.teamId;
        let chatUser = storage.getChat();
        let chat = _.find(chatUser, user => user.id == teamIdX);
        if (!chat) {
            log.debug(store.state.allGroups);
            let allGroup = store.state.allGroups;


            let chatX = _.find(allGroup, friend => friend.id === teamIdX);

            if (chatX) { //当前群组存在
                console.log("======------");
                chatX.chatNum = 1;
                chatX.lastMsg = msg;
                storage.saveChat(chatX);
            } else {//当前群组不存在
                http.getAllGroups().then(res => {
                    if (res.code === 'success') {
                        store.commit('setAllGroups', res.data);

                        let chatX = _.find(store.state.allGroups, friend => friend.id === teamIdX);
                        chatX.chatNum = 1;
                        chatX.lastMsg = msg;
                        storage.saveChat(chatX);
                    }
                });
            }


        } else {
            if (!chat.chatNum) {
                chat.chatNum = 0;
            }
            chat.chatNum = chat.chatNum + 1;
            chat.lastMsg = msg;
            storage.replaceChat(chatUser);
            let talkTemp = 0;
            for (let i = 0; i < chatUser.length; i++) {
                talkTemp += chatUser[i].chatNum;
            }
            let dots = {
                type: 'chat',
                num: talkTemp
            }
            store.dispatch('setDotActive', dots);
        }
    },
    onMessage(callback, key) {
        if (key) {
            let index = _.findIndex(this.messageKey, item => {
                return item === key;
            });
            if (index >= 0) {
                this.messageKey.splice(index, 1);
                this.messageEvent.splice(index, 1);
            }
        }
        this.messageEvent.push(callback);
        this.messageKey.push(key);
    },
    send(msg) {
        if (this.webSocket) {
            if (typeUtil.isObject(msg)) {
                msg = JSON.stringify(msg);
            }
            this.webSocket.send(msg);
        }
    },
    close() {
        if (this.webSocket) {
            this.webSocket.close();
        }
    },
    createMessage(toId, msgType, contentType, scene, content) {
        return {
            msgType: msgType,
            fromClientType: 'Android',
            fromDeviceId: '2',
            timestamp: Date.getUtcTick(),
            contentType: contentType,
            state: 'sending',
            fromId: storage.get('userId'),
            toId: toId,
            scene: scene,
            content: content
        }
    },
    createAckHandlerMessage(msg) {
        msg = toolUtil.deepClone(msg);
        msg.msgType = 'ackHandler';
        msg.sourceId = msg.id;
        return msg;
    }
};

setInterval(() => {
    if (!socket.isOpen) {
        log.debug("socket重新连接");
        let token = storage.get('token');
        if (token) {
            socket.connect(token);
        }

    }
}, 1000);
export default socket;
